export const UNIT_CREATION_MODES = {
	CREATE_NEW: 'CREATE_NEW',
	COPY_EXISTING: 'COPY_EXISTING'
};

export const CONFIG_KEY_CONSTANTS = {
	ADUNITS_DESKTOP_DEFAULT_UNITS_KEY: 'networkData.dfpAdUnits.DESKTOP.defaultUnits',
	ADUNITS_DESKTOP_BACKFILL_UNITS_KEY: 'networkData.dfpAdUnits.DESKTOP.backfillUnits',
	ADUNITS_DESKTOP_NO_MCM_UNITS_KEY: 'networkData.dfpAdUnits.DESKTOP.noMcmUnits',
	ADUNITS_MOBILE_DEFAULT_UNITS_KEY: 'networkData.dfpAdUnits.MOBILE.defaultUnits',
	ADUNITS_MOBILE_BACKFILL_UNITS_KEY: 'networkData.dfpAdUnits.MOBILE.backfillUnits',
	ADUNITS_MOBILE_NO_MCM_UNITS_KEY: 'networkData.dfpAdUnits.MOBILE.noMcmUnits',
	ADUNITS_TABLET_DEFAULT_UNITS_KEY: 'networkData.dfpAdUnits.TABLET.defaultUnits',
	ADUNITS_TABLET_BACKFILL_UNITS_KEY: 'networkData.dfpAdUnits.TABLET.backfillUnits',
	ADUNITS_TABLET_NO_MCM_UNITS_KEY: 'networkData.dfpAdUnits.TABLET.noMcmUnits'
};

export const SPLIT_LABEL = {
    experiment: 'ES',
    control: 'CS',
    normal: 'NS'
};

export const splitInfoKeyMapping = {
    EXPERIMENT_SPLIT: 'abSplitTestData',
    MULTI_SPLIT: 'multiSplitTestData'
};

